import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton, ButtonProps } from '@material-ui/core';

import { Icons } from 'components/Icons';

interface IButton {
  fullWidth?: boolean;
}
const Button = styled(MuiButton)<IButton>`
  &.MuiButton-root {
    text-transform: inherit;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--white);
    width: 100%;
    min-width: 88px;
    height: 40px;
    background: var(--orange);
    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25); */
    @media(min-width: 600px) {
      width: ${({fullWidth}) => fullWidth ? '100%' : '160px'};
    }
    
    &:hover {
      background: var(--orangeHover);
    }
  }
`;

interface ButtonAddProps extends ButtonProps {
  children: React.ReactNode;
}

export default function ButtonAdd({ children, ...rest }: ButtonAddProps) {
  return (
    <Button {...rest}>
      <Icons.Add style={{ marginRight: '4px' }}/>
      {children}
    </Button>
  )
}
